module.exports = __webpack_public_path__ + "static/media/WoT.741ab424.jpg";